import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { motion } from 'motion/react';
import React__default, { useRef } from 'react';
import { cn } from '../lib/utils.js';

const StoreCarousel = (_a) => {
    var { children, styleProps, gap = 15 } = _a, props = __rest(_a, ["children", "styleProps", "gap"]);
    const carouselRef = useRef(null);
    const itemRefs = useRef([]);
    return (jsxs("div", Object.assign({ className: cn('tw:relative tw:w-full tw:max-w-full tw:overflow-hidden tw:flex tw:justify-start tw:items-center') }, styleProps, { children: [jsx("style", { children: `
        .store-carousel-scroll::-webkit-scrollbar {
          display: none;
        }
      ` }), jsx(motion.div, Object.assign({ ref: carouselRef, style: {
                    gap: `${gap}px`,
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none', // IE/Edge
                }, className: cn('store-carousel-scroll', 'tw:flex tw:overflow-auto tw:[scroll-snap-type:x_mandatory]') }, props, { children: React__default.Children.map(children, (child, index) => (jsx("div", Object.assign({ className: "tw:snap-start tw:shrink-0", ref: (ref) => {
                        const current = itemRefs.current[index];
                        if (current && !ref) {
                            itemRefs.current = itemRefs.current.filter((_, i) => i !== index);
                            return;
                        }
                        itemRefs.current[index] = ref;
                    } }, { children: child }), index))) }), children.length)] })));
};

export { StoreCarousel as default };
//# sourceMappingURL=StoreCarousel.js.map
